import React, { useState } from 'react';
import './ContactLensParamsDropdown.scss';
import { useSelector } from 'react-redux';

import OdCheckIcon from '../../../../../../../static/assets/svg/od-check-icon.svg';
import OdChevronDownBlackIcon from '../../../../../../../static/assets/svg/od-chevron-down-thin-black-icon.svg';

const ContactLensParamsDropdown = ({ type, options, selectOptionCallback }) => {
  const { SELECT, BOX } = useSelector(state => state.locale);

  const [showOptions, setShowOptions] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const value = selectedOption
    ? type === 'boxes'
      ? `${selectedOption} ${BOX}`
      : selectedOption
    : SELECT;

  const getConsolidatedOptions = () => {
    return [...(options.positive || []), ...(options.negative || [])];
  };

  const consolidatedOptions = getConsolidatedOptions();

  const handleSelectOption = option => {
    selectOptionCallback(option);
    setSelectedOption(option);
    setShowOptions(false);
  };

  return (
    <div className="contact-lens-params-dropdown-wrapper">
      <label
        className={`contact-lens-params-dropdown-toggler ${
          showOptions ? 'contact-lens-params-dropdown-toggler--open' : ''
        }`}
      >
        <input
          className={`contact-lens-params-dropdown-toggler__input ${
            selectedOption ? 'od-font-bold' : 'od-font-light'
          }`}
          type="button"
          value={value}
          onClick={() => setShowOptions(prev => !prev)}
        />
        <img
          alt={SELECT}
          className={`contact-lens-params-dropdown-toggler__icon ${
            showOptions ? 'contact-lens-params-dropdown-toggler__icon--open' : ''
          }`}
          src={OdChevronDownBlackIcon}
        />
      </label>

      {showOptions && (
        <div className="contact-lens-params-dropdown-options">
          {consolidatedOptions.map(option => (
            <div
              key={option}
              className={`contact-lens-params-dropdown-options__option ${
                option === selectedOption ? 'od-font-bold' : 'od-font-reg'
              }`}
              onClick={() => handleSelectOption(option)}
            >
              {option} {type === 'boxes' && BOX.toLowerCase()}
              {option === selectedOption && <img alt="Selected" src={OdCheckIcon} />}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ContactLensParamsDropdown;
